(function() {

    // Add the directive to the module
    angular.module("Sinewav3.Client.Shell")
        .directive(
            'cardDisplay',
            [
                'SECTIONS',
                CardDisplayFactory
            ]
        );

    // Factory Method
    function CardDisplayFactory(SECTIONS)
    {
        // Construct and return the instance
        return {
            restrict: 'E',
            scope: false,
            templateUrl: SECTIONS.PREFIX + SECTIONS.ACCOUNT.PROFILE_CARD_DISPLAY + SECTIONS.POSTFIX
        };

    }
})();



